/**
 * N-288 · 4A (decisión de Bernardo, 7-oct-2026) · Mientras llega algún catálogo de precios, GUARDAR
 * está en gris con «Actualizando los precios para N pasajeros…» al lado: si no, se guardaba la tarifa
 * del tramo viejo y el servidor borraba en silencio lo que no casaba (en staging, más de 4 s).
 *
 * El formulario (el del presupuesto y el del paquete) crea una espera y se la ofrece a sus pestañas
 * con `provide`; cada selector que pide un catálogo de precios la recoge con `inject` y cuenta su
 * petición mientras está en camino. El campo de pasajeros dice qué número se está tecleando durante
 * el medio segundo que se espera antes de pedir precios. Fuera de un formulario (sin espera), nada.
 */
export const ESPERA_DE_PRECIOS = 'esperaDePrecios';

// Lo que se espera tras la última tecla de los pasajeros antes de pedir precios: teclear «57» pedía
// los de 5 y los de 57.
export const MEDIO_SEGUNDO = 500;

export interface EsperaDePrecios {
	// Catálogos pedidos que aún no han llegado (o no se han terminado de leer).
	enCamino: number;
	// El número que se está tecleando y aún no se ha pedido; `null` si no hay tecla pendiente.
	tecleando: number | null;
}

export function nuevaEspera(): EsperaDePrecios {
	return { enCamino: 0, tecleando: null };
}

/**
 * Cuenta la petición mientras está en camino. Se le pasa la cadena ENTERA (la petición con su
 * `then` y su `catch`): así deja de contar cuando la respuesta ya se ha leído, y también si falla.
 */
export function contarPedido<T>(espera: EsperaDePrecios | null, pedido: Promise<T>): Promise<T> {
	if (!espera) {
		return pedido;
	}
	espera.enCamino++;
	const llegado = () => {
		espera.enCamino--;
	};
	pedido.then(llegado, llegado);
	return pedido;
}

/**
 * El texto junto a GUARDAR, o '' si no hay que esperar. Con el campo vacío (o un número que no
 * vale) no se dice nada y GUARDAR sigue normal: al pulsarlo sale el error del campo (8-oct).
 */
export function textoDeEspera(espera: EsperaDePrecios | null, pasajeros: any): string {
	if (!espera || (espera.tecleando === null && espera.enCamino === 0)) {
		return '';
	}
	const numero = espera.tecleando !== null ? espera.tecleando : Number(pasajeros);
	if (!Number.isInteger(numero) || numero <= 0) {
		return '';
	}
	return `Actualizando los precios para ${numero === 1 ? '1 pasajero' : numero + ' pasajeros'}…`;
}
